import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/eventLog": {
        title: "Event Log",
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/partiallyMatched": {
            title: "Partially Matched Event Log"
        }
    }
};
